import { TFunction } from 'i18next';
import moment from 'moment';
import { BEHAVIOR } from '../constants';
import TRANSLATIONS from '../translations';
import momentLocaleRemap from './momentLocaleRemap';

const toDateDisplayText = (dateString: string, t: TFunction, locale: string) => {
  const dateToConvert = moment(dateString, BEHAVIOR.DATE_FORMAT);
  dateToConvert.locale(momentLocaleRemap(locale));

  const now = moment();
  const numDaysAgo = now.diff(dateToConvert, 'days');
  if (numDaysAgo === 0) return t(...TRANSLATIONS.COMMON.TODAY);
  if (numDaysAgo === 1) return t(...TRANSLATIONS.COMMON.YTD);
  if (numDaysAgo <= 7) return dateToConvert.format('dddd');
  return dateString;
};

export default toDateDisplayText;
